import { render, staticRenderFns } from "./UsersPanel.vue?vue&type=template&id=107647fc&"
import script from "./UsersPanel.vue?vue&type=script&lang=js&"
export * from "./UsersPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/users/UsersPanel.vue
// module id = 1427
// module chunks = 0